import { render, staticRenderFns } from "./ButtonRedoingTest.vue?vue&type=template&id=2fa4c167&scoped=true"
import script from "./ButtonRedoingTest.vue?vue&type=script&lang=js"
export * from "./ButtonRedoingTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa4c167",
  null
  
)

export default component.exports